// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-history-panel {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  width: min(260px, 82vw);
  max-width: 100%;
  height: 100%;
  background: #F9F9F9;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  z-index: 30;
  transform: translateX(-110%);
  transition: transform 0.25s ease;
  display: flex;
  flex-direction: column;
  min-height: 0;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

[dir=rtl] .chat-history-panel {
  transform: translateX(110%);
}

.chat-history-panel.open {
  transform: translateX(0);
}

.chat-history-panel.collapsed {
  transform: translateX(-110%);
  box-shadow: none;
}

[dir=rtl] .chat-history-panel.collapsed {
  transform: translateX(110%);
}

.chat-history-header {
  padding: 17px 14px;
  border-bottom: 3px solid #2c68ad;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F9F9F9;
}
.chat-history-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #2966AF;
  margin: 0;
}

.history-close {
  background: #fafafa;
  border: none;
  font-size: 14px;
  cursor: pointer;
  color: #2966AF;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.history-close:hover {
  background-color: #e5e7eb;
  border-color: #d1d5db;
}

.chat-history-search {
  padding: 12px 14px;
  margin-top: 5px;
}

.chat-history-search input {
  width: 100%;
  height: 38px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  font-family: "opensans", sans-serif;
  color: #111827;
  outline: none;
}
.chat-history-search input:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.2);
}

.chat-history-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 6px 0;
}

.chat-history-section {
  margin-bottom: 8px;
}

.chat-history-group-title {
  font-size: 10px;
  font-weight: 600;
  font-family: "opensans", sans-serif;
  color: #A1A1A1;
  padding: 6px 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.history-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
  transition: background 0.15s ease;
  border-radius: 8px;
  margin: 0 8px;
}
.history-item:hover {
  background: #f9fafb;
}
.history-item:hover .history-item-menu-btn, .history-item.menu-open .history-item-menu-btn {
  opacity: 1;
  pointer-events: auto;
}

.history-item-actions {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.history-item-menu-btn {
  opacity: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #6a6a6a;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}
.history-item-menu-btn:hover {
  background-color: #e5e7eb;
  color: #2966af;
}

.history-item-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 40;
  min-width: 150px;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.16);
}

.history-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-size: 13px;
  font-family: "opensans", sans-serif;
  color: #374151;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease;
}
.history-dropdown-item:hover {
  background-color: #f3f4f6;
}
.history-dropdown-item.danger {
  color: #e53935;
}
.history-dropdown-item.danger:hover {
  background-color: #fee2e2;
}
.history-dropdown-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.history-item.active {
  background: #eef4ff;
  border-left: 3px solid #2563eb;
  margin-left: 6px;
  padding-left: 9px;
}

.history-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}
.history-icon svg {
  width: 16px;
  height: 16px;
}

.history-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
}

.history-title {
  font-size: 14px;
  font-weight: 400;
  color: #6A6A6A;
  font-family: "opensans", sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.history-sub {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  font-family: "opensans", sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
}

.loading-state,
.error-state,
.empty-state {
  font-size: 12px;
  font-family: "opensans", sans-serif;
  color: #6b7280;
  padding: 8px 12px;
}

.chat-history-footer {
  padding: 16px 12px;
  font-size: 12px;
  font-weight: 400;
  color: #6A6A6A;
  border-top: 2px solid #e5e7eb;
  background: #F9F9F9;
  text-align: center;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

@media (max-width: 992px) {
  .chat-history-panel {
    position: absolute;
    z-index: 60;
    width: min(320px, 88vw);
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: 10px 0 24px rgba(15, 23, 42, 0.18);
  }
}
@media (max-width: 480px) {
  .chat-history-panel {
    width: min(100%, 92vw);
    border-radius: 0;
  }
  .chat-history-header {
    padding: 14px 12px;
  }
  .chat-history-search {
    padding: 10px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/AskDatatram/ChatHistorySidebar.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,6CAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,4BAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACI,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAAJ;;AAIA;EACK,mBAAA;EACD,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AADJ;AAGE;EACE,yBAAA;EACA,qBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,cAAA;EACA,aAAA;AAFF;AAIE;EACE,qBAAA;EACA,8CAAA;AAFJ;;AAMA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;AAOE;EAEE,UAAA;EACA,oBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAPF;;AAUA;EACE,UAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,6EAAA;AAPF;AASE;EACE,yBAAA;EACA,cAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uCAAA;AARF;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,cAAA;AATJ;AAWI;EACE,yBAAA;AATN;AAaE;EACE,YAAA;EACA,mBAAA;AAXJ;;AAeA;EACE,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAZF;AAcE;EACE,WAAA;EACA,YAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,uBAAA;AAbF;;AAgBA;;;EAGE,eAAA;EACA,mCAAA;EACA,cAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,gCAAA;AAbF;;AAgBA;EACE;IACE,kBAAA;IACA,WAAA;IACA,uBAAA;IACA,0BAAA;IACA,6BAAA;IACA,8CAAA;EAbF;AACF;AAgBA;EACE;IACE,sBAAA;IACA,gBAAA;EAdF;EAiBA;IACE,kBAAA;EAfF;EAkBA;IACE,kBAAA;EAhBF;AACF","sourcesContent":[".chat-history-panel {\n  position: absolute;\n  top: 0;\n  inset-inline-start: 0;\n  width: min(260px, 82vw);\n  max-width: 100%;\n  height: 100%;\n  background: #F9F9F9;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  z-index: 30;\n  transform: translateX(-110%);\n  transition: transform 0.25s ease;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);\n}\n\n[dir=\"rtl\"] .chat-history-panel {\n  transform: translateX(110%);\n}\n\n.chat-history-panel.open {\n  transform: translateX(0);\n}\n\n.chat-history-panel.collapsed {\n  transform: translateX(-110%);\n  box-shadow: none;\n}\n\n[dir=\"rtl\"] .chat-history-panel.collapsed {\n  transform: translateX(110%);\n}\n\n.chat-history-header {\n    padding: 17px 14px;\n    border-bottom: 3px solid #2c68ad;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #F9F9F9;\n\n\n  h4 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #2966AF;\n    margin: 0;\n  }\n}\n\n.history-close {\n     background: #fafafa;\n    border: none;\n    font-size: 14px;\n    cursor: pointer;\n    color: #2966AF;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    transition: background-color 0.2s ease, border-color 0.2s ease;\n\n  &:hover {\n    background-color: #e5e7eb;\n    border-color: #d1d5db;\n  }\n}\n\n.chat-history-search {\n  padding: 12px 14px;\n  margin-top:5px;\n}\n\n.chat-history-search input {\n  width: 100%;\n  height: 38px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-family: \"opensans\", sans-serif;\n  color: #111827;\n  outline: none;\n\n  &:focus {\n    border-color: #94a3b8;\n    box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.2);\n  }\n}\n\n.chat-history-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 6px 0;\n}\n\n.chat-history-section {\n  margin-bottom: 8px;\n}\n\n.chat-history-group-title {\n  font-size: 10px;\n  font-weight: 600;\n  font-family: \"opensans\", sans-serif;\n  color: #A1A1A1;\n  padding: 6px 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.history-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  border-radius: 8px;\n  margin: 0 8px;\n\n  &:hover {\n    background: #f9fafb;\n  }\n\n  // Reveal the options button on hover or while its menu is open.\n  &:hover .history-item-menu-btn,\n  &.menu-open .history-item-menu-btn {\n    opacity: 1;\n    pointer-events: auto;\n  }\n}\n\n.history-item-actions {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.history-item-menu-btn {\n  opacity: 0;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #6a6a6a;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n\n  &:hover {\n    background-color: #e5e7eb;\n    color: #2966af;\n  }\n}\n\n.history-item-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  z-index: 40;\n  min-width: 150px;\n  padding: 4px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.16);\n}\n\n.history-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  font-size: 13px;\n  font-family: \"opensans\", sans-serif;\n  color: #374151;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: #f3f4f6;\n  }\n\n  &.danger {\n    color: #e53935;\n\n    &:hover {\n      background-color: #fee2e2;\n    }\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.history-item.active {\n  background: #eef4ff;\n  border-left: 3px solid #2563eb;\n  margin-left: 6px;\n  padding-left: 9px;\n}\n\n.history-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.history-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n}\n\n.history-title {\n  font-size: 14px;\n  font-weight: 400;\n  color: #6A6A6A;\n  font-family: \"opensans\", sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.history-sub {\n  font-size: 11px;\n  color: #6b7280;\n  margin-top: 2px;\n  white-space: nowrap;\n  font-family: \"opensans\", sans-serif;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.loading-state,\n.error-state,\n.empty-state {\n  font-size: 12px;\n  font-family: \"opensans\", sans-serif;\n  color: #6b7280;\n  padding: 8px 12px;\n}\n\n.chat-history-footer {\n  padding: 16px 12px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #6A6A6A;\n  border-top: 2px solid #e5e7eb;\n  background: #F9F9F9;\n  text-align: center;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n@media (max-width: 992px) {\n  .chat-history-panel {\n    position: absolute;\n    z-index: 60;\n    width: min(320px, 88vw);\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    box-shadow: 10px 0 24px rgba(15, 23, 42, 0.18);\n  }\n}\n\n@media (max-width: 480px) {\n  .chat-history-panel {\n    width: min(100%, 92vw);\n    border-radius: 0;\n  }\n\n  .chat-history-header {\n    padding: 14px 12px;\n  }\n\n  .chat-history-search {\n    padding: 10px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
